import request from '@/plugins/axios'

//东方网单点登录
export function easynet(params) {
  return request({
    url: '/sso/eastnet/login',
    method: 'get',
    params
  })
}


//单点登录
export function ssoLogin(params) {
  return request({
    url: '/sso/common/ssoLogin',
    method: 'get',
    params
  })
}
